/**
 * `@page` cannot be scoped to a class or written inline: it is a top-level rule
 * whose values have to be rewritten when the print settings change. So the app
 * owns one stylesheet element and keeps it in sync.
 */

import { pageGeometry, type PrintSettings } from './print';

const STYLE_ID = 'chrono-page-setup';

export function applyPageSetup(settings: PrintSettings): void {
  const { widthMm, heightMm, marginBlockMm, marginInlineMm } = pageGeometry(settings);
  const orientation = widthMm > heightMm ? 'landscape' : 'portrait';

  let style = document.querySelector<HTMLStyleElement>(`#${STYLE_ID}`);
  if (!style) {
    style = document.createElement('style');
    style.id = STYLE_ID;
    document.head.append(style);
  }

  style.textContent = `@page { size: A4 ${orientation}; margin: ${marginBlockMm}mm ${marginInlineMm}mm; }`;
}
